import React, { useState, useEffect } from "react";
import { useNavigate} from "react-router-dom";
import "./EventPage.css";
import emailjs from "@emailjs/browser";
import image1 from "./image1.jpg";
import image2 from "./image2.jpg";
import image3 from "./image3.jpg";
import image4 from "./image4.jpeg";
import image5 from "./image5.png";
import CoolIshr from "./Cool-Ishrae-e1715666840667-2048x717.png";
import ACREX from "./Arex.png";
import Peda from "./logopde.png";
import MANU from "./MANU.jpg";
import WefixLogo11 from "./logo10.png";
import LogoD2o from "./logoD2o.png"; 

import RajisthanLOgo11 from "./Rj.png";
import Griha from "./griha.png";
import { IoSpeedometerOutline } from "react-icons/io5";
import { BsCalendar2Check } from "react-icons/bs";
import { FaPhoneAlt } from "react-icons/fa";
import Steps from "./Steps"
// import Testimonials from "./Testimonials";
import CountUp from "react-countup";
import Footer from "./Footer";
import elogo from './elogo.png'
import PricingCards from "./pricing";
import Benefits from "./Benefits";
import CTA from "./CTA";
import ProductSection from './products/ProductSection'






function EventPage() {
  const images = [image1, image2, image3, image4, image5];
  // Each image gets a unique style for the collage
  const collageStyles = [
    { className: 'collage-rect', style: {} },
    { className: 'collage-circle', style: {} },
    { className: 'collage-polaroid', style: {} },
    { className: 'collage-rect2', style: {} },
    
  ];

  const sendEmail = (e) => {
    e.preventDefault();
  
    const formData = new FormData(e.target);
    const data = {
      from_firstname: formData.get("from_firstname"),
      from_lastname: formData.get("from_lastname"),
      from_phonenumber: formData.get("from_phonenumber"),
      country: formData.get("country"),
      from_emailid: formData.get("from_emailid"),
      organization: formData.get("organization"),
      message: formData.get("message"),
    };
  
    console.log("Data being sent:", data);
  
    emailjs
      .send("service_nxepswl", "template_jumzlyr", data, "Ei4GRgZo9kOlQvyW9")
      .then((response) => {
        console.log("Email sent successfully", response);
        alert("Your message has been sent successfully!");
      })
      .catch((error) => {
        console.error("Email sending failed", error);
        alert("Sorry, something went wrong. Please try again later.");
      });
  };

  const [isOpen, setIsOpen] = useState(false);

  const togglePopup = () => {
    setIsOpen(!isOpen);
  };

  const handleFormSubmit = async (event) => {
    event.preventDefault();
    try {
      await sendEmail(event);
      togglePopup();
    } catch (error) {
      console.error("Error submitting the form:", error);
    }
  };
  
  const navigate = useNavigate();
  
  const handleLogin = () => {
    navigate("/login");
    window.history.go(-1);
  };
  
 
  const [order, setOrder] = useState([0, 1, 2, 3]);
  const [fading, setFading] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setFading(true);
      setTimeout(() => {
        setOrder((prev) => {
          const newOrder = [...prev.slice(1), prev[0]];
          return newOrder;
        });
        setFading(false);
      }, 350); 
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="main-page">
      <div className="main-flex-row">
        <div className="main-page-banner">
        <img src={elogo}alt="elogo" />
        

          <h1>Organize Events that Leave, No Carbon Footprint Behind</h1>
          <p>Use the most trusted carbon tracking tool built exclusively for Events</p>
          <div className="main-page-banner-button">
            
            <button style={{ '--clr': '#7808d0' }} className="button-start" onClick={handleLogin}>
              <span className="button__icon-wrapper">
                <svg
                  width="10"
                  className="button__icon-svg"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 14 15"
                >
                  <path
                    fill="currentColor"
                    d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"
                  ></path>
                </svg>
                <svg
                  className="button__icon-svg button__icon-svg--copy"
                  xmlns="http://www.w3.org/2000/svg"
                  width="10"
                  fill="none"
                  viewBox="0 0 14 15"
                >
                  <path
                    fill="currentColor"
                    d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"
                  ></path>
                </svg>
              </span>
              Get Started for FREE
            </button>
            
            <button className="demo" onClick={togglePopup}>Request for Demo<FaPhoneAlt /> </button>
          </div> 
        </div>
      </div>
    
      <div className="marqueep-page">
      
        <div className="marqueep">
    
      <img src={CoolIshr} alt="Logo 1" />
      <img src={ACREX} alt="Logo 2" />
      <img src={Peda} alt="Logo 3" />
      <img src={MANU}alt="Logo 4" />
     
      <img src={WefixLogo11}alt="Logo 1" />
      <img src={LogoD2o} alt="Logo 2" />
     
      <img src={RajisthanLOgo11}alt="Logo 4" />
      <img src={Griha}alt="Logo 4" />
      <img src={RajisthanLOgo11}alt="Logo 4" />
      <img src={Griha}alt="Logo 4" />
      <img src={CoolIshr} alt="Logo 1" />
      <img src={ACREX} alt="Logo 2" />
      <img src={Peda} alt="Logo 3" />
      <img src={MANU} alt="Logo 4" />
      <img src={WefixLogo11} alt="Logo 5" />
      <img src={LogoD2o} alt="Logo 6" />
      <img src={RajisthanLOgo11} alt="Logo 7" />
      <img src={Griha} alt="Logo 8" />
      <img src={CoolIshr} alt="Logo 1" />
      <img src={ACREX} alt="Logo 2" />
      <img src={Peda} alt="Logo 3" />
      <img src={MANU} alt="Logo 4" />
      <img src={WefixLogo11} alt="Logo 5" />
      <img src={LogoD2o} alt="Logo 6" />
      <img src={RajisthanLOgo11} alt="Logo 7" />
      <img src={Griha} alt="Logo 8" />

    </div>
    <div> <p> <i>Trusted by forward-thinking event organizers worldwide</i></p></div>
      </div>


      <div className="numbers-page">
        <div className="scrapbook-collage">
          {order.map((imgIdx, i) => (
            <div
              key={imgIdx}
              className={`scrap-img ${collageStyles[i].className} ${fading ? 'fade-out' : 'fade-in'}`}
              style={collageStyles[i].style}
            >
              <img src={images[imgIdx]} alt={`Collage ${i}`} />
              
              
            </div>
          ))}
         
        </div>
        <div className="numbers-info">
          <div className="numbers-info-block">
            <div >
              <span className="numbers-icon"><BsCalendar2Check /></span>
            </div>
            <div>
            <div className="numbers-value" style={{ width: "60px", textAlign: "right" }}>
  <CountUp 
    start={1}
    end={20}
    duration={2}
    suffix="+"
  />
</div>


              <div className="numbers-label">Events Tracked</div>
            </div>
          </div>
          <div className="numbers-info-block">
            <div >
              <span className="numbers-icon" ><IoSpeedometerOutline /></span>
            </div>
            <div>
            <div className="numbers-value" style={{ width: "400px", textAlign: "left" }}>
  <CountUp 
    start={1000}
    end={2759.51}
    duration={2}
    decimals={2}
    separator=","
  />
  <span className="unit"> tonnes CO₂e</span>
</div>

{isOpen && (
                <div className="popup">
                  <div className="popup-content">
                    <span className="close-icon" onClick={togglePopup}>
                      &times;
                    </span>
                    <h2 className="popup-title">
                      Schedule a Call <i class="fa fa-phone"></i>
                    </h2>

                    <form className="popup-form" onSubmit={handleFormSubmit}>
                      <div className="input-row">
                        <div className="input-group half-width">
                          <label>First Name</label>
                          <input type="text" name="from_firstname" required />
                        </div>
                        <div className="input-group half-width">
                          <label>Last Name</label>
                          <input type="text" name="from_lastname" required />
                        </div>
                      </div>

                      <div className="input-row">
                        <div className="input-group half-width">
                          <label>Phone No.</label>
                          <input type="tel" name="from_phonenumber" required />
                        </div>
                        <div className="input-group half-width">
                          <label>Country</label>
                          <input type="text" name="country" required />
                        </div>
                      </div>

                      <div className="input-group">
                        <label>Email</label>
                        <input type="email" name="from_emailid" required />
                      </div>

                      <div className="input-group">
                        <label>Organization</label>
                        <input type="text" name="organization" required />
                      </div>

                      <div className="input-group">
                        <label>What do you want to know?</label>
                        <textarea name="message" required></textarea>
                      </div>

                      <div className="popup-buttons">
                        <button type="submit" className="submit-button">
                          Submit
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              )}

              <div className="numbers-label">Emissions Monitored</div>
            </div>
          </div>
        </div>
      </div>
      <Steps/>
      <Benefits/>
      <ProductSection/>
      {/* <Testimonials/> */}
      <PricingCards/>
      <CTA/>
      <Footer/>
    </div>
  );
}

export default EventPage;
 